import common from './common.json';
import dashboard from './dashboard.json';
import customers from './customers.json';
import couriers from './couriers.json';
import scanIn from './scanIn.json';
import packages from './packages.json';
import invoices from './invoices.json';
import deliveryRequest from './deliveryRequest.json';
import manifests from './manifests.json';
import pos from './pos.json';
import communication from './communication.json';
import marketing from './marketing.json';
import whatsapp from './whatsapp.json';
import warehouse from './warehouse.json';
import users from './users.json';
import authorizedUsers from './authorizedUsers.json';
import billing from './billing.json';
import settings from './settings.json';
import mailSettings from './mailSettings.json';
import addOns from './addOns.json';
import attendance from './attendance.json';
import payroll from './payroll.json';
import warehouseHub from './warehouseHub.json';
import packageRequests from './packageRequests.json';
import customerIssues from './customerIssues.json';
import scanBonusReport from './scanBonusReport.json';
import partnerCompliance from './partnerCompliance.json';
import reviewsGallery from './reviewsGallery.json';
import expenses from './expenses.json';
import emailForwarding from './emailForwarding.json';
import tasokoFeeds from './tasokoFeeds.json';
import customs from './customs.json';

const es = {
  ...common,
  ...dashboard,
  ...customers,
  ...couriers,
  ...scanIn,
  ...packages,
  ...invoices,
  ...deliveryRequest,
  ...manifests,
  ...pos,
  ...communication,
  ...marketing,
  ...whatsapp,
  ...warehouse,
  ...users,
  ...authorizedUsers,
  ...billing,
  ...settings,
  ...mailSettings,
  ...addOns,
  ...attendance,
  ...payroll,
  ...warehouseHub,
  ...packageRequests,
  ...customerIssues,
  ...scanBonusReport,
  ...partnerCompliance,
  ...reviewsGallery,
  ...expenses,
  ...emailForwarding,
  ...tasokoFeeds,
  ...customs,
};

export default es;
